import { useCallback, useEffect, useState } from 'react';

import { Api } from '../../api/api';

import type { SkillDetailState } from './SkillDetailState';

/** Mirrors android/…/Screens/SkillDetail/SkillDetailViewModel.kt. */
export function useSkillDetail(childId: string | null, skillCode: string | null) {
  const [state, setState] = useState<SkillDetailState>({
    isLoading: true,
    detail: null,
    error: null,
    errorCorrelationId: null,
  });

  const load = useCallback(async (): Promise<void> => {
    if (childId === null || skillCode === null) return;

    setState((current) => ({ ...current, isLoading: true, error: null, errorCorrelationId: null }));

    const result = await Api.readSkillDetail(childId, skillCode);

    setState(
      result.ok
        ? { isLoading: false, detail: result.value, error: null, errorCorrelationId: null }
        : {
            isLoading: false,
            detail: null,
            error: result.error.message,
            errorCorrelationId: result.error.correlationId ?? null,
          },
    );
  }, [childId, skillCode]);

  useEffect(() => {
    void load();
  }, [load]);

  return { state, load };
}
